import {
  Article as Ar,
  EventCategoryEntry,
  PersonalNavigationEntry,
} from "../helper/interfaces";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import { AppTheme, EventCategoryType } from "../helper/enums";
import { useLoggedRouter } from "../helper/useLoggedRouter";
import { AppContext } from "../provider/AppContextProvider";
import { Heart } from "react-feather";

interface Data {
  article: Ar | null;
  navigate?: (id?: string, ressortId?: string) => void;
}

function LinkedCategories(data: Data) {
  const { personalResorts, setPersonalResorts } = React.useContext(AppContext);
  const [showError, setShowError] = useState(false);

  const article = data.article;
  const [routerPush] = useLoggedRouter();

  const internalNavigate = async (e, id, ressortId) => {
    e.stopPropagation();
    e.preventDefault();

    if (data.navigate) {
      data.navigate(id, ressortId);
    } else if (id) {
      await routerPush(`/article/${encodeURIComponent(id)}`);
    } else if (ressortId) {
      await routerPush(`/article/${encodeURIComponent(ressortId)}`);
    }
  };

  const convertEventToRessortItem = (
    item: EventCategoryEntry
  ): PersonalNavigationEntry => {
    return {
      id: item.id,
      title: item.title,
      links: item.links ?? [],
    };
  };

  const addToMyNews = (item: EventCategoryEntry) => {
    const ressortItem = convertEventToRessortItem(item);
    if (personalResorts.length <= 2 && !isItemIncluded(item)) {
      setPersonalResorts([...personalResorts, ressortItem]);
    }
  };

  const removeFromMyNews = (item: EventCategoryEntry) => {
    setPersonalResorts(personalResorts.filter((e) => e.id !== item.id));
  };

  const isItemIncluded = (item: EventCategoryEntry) => {
    return personalResorts.find((m) => m.id == item.id) != undefined;
  };

  const isMaxNews = personalResorts?.length == 3;

  useEffect(() => {
    if (!isMaxNews) {
      setShowError(false);
    }
  }, [isMaxNews]);

  const isNN = process.env.NEXT_PUBLIC_APP_THEME === AppTheme.nn;

  return (
    <React.Fragment>
    {!isNN && article && article.linkedCategories && article.linkedCategories.length > 0 &&
      <div className="px-4">
          <div className="linked_headline">Verwandte Themen</div>
          <div className="flex flex-wrap gap-x-2">
            {article.linkedCategories.map((entry) => (
              <React.Fragment key={entry.id}>
                { entry.type == EventCategoryType.Ressort &&
                  <Link key={`linked-ressort-${entry.id}`} href={`/ressort/${entry.id}`} className="btn btn-primary btn-discreet" onClick={(e) => { internalNavigate(e, null, entry.id) }}>
                      {entry.title}
                  </Link>
                }
                { entry.type == EventCategoryType.Detail &&
                  <Link key={`linked-ressort-${entry.id}`} href={`/article/${entry.id}`} className="btn btn-primary btn-discreet" onClick={(e) => { internalNavigate(e, entry.id, null) }}>
                      {entry.title}
                  </Link>
                }
                { entry.type == EventCategoryType.Web && entry.link &&
                  <Link key={`linked-webview-${entry.id}`} href={entry.link} target="_blank" className="btn btn-primary btn-discreet">
                      {entry.title}
                  </Link>
                }
              </React.Fragment>
            ))}
          </div>
        </div>
        }
      {isNN && article && article.linkedCategories && article.linkedCategories.length > 0 && (
        <div className="px-2 py-4 pt-1">
          {process.env.NEXT_PUBLIC_APP_THEME != AppTheme.nn && (
            <div className="linked_headline">Verwandte Themen</div>
          )}
          <div className="flex items-stretch">
            <div className="add-to-list">
              {article.linkedCategories.map((entry) => {
                const isIncluded = isItemIncluded(entry);

                return (
                  <React.Fragment key={entry.id}>
                    {(entry.type == EventCategoryType.Ressort ||
                      entry.type == EventCategoryType.Detail) && (
                      <div className="add-tag">
                            {entry.type == EventCategoryType.Ressort && (
                              <div className="list-item-add">
                                <Link
                                  key={`linked-ressort-${entry.id}`}
                                  href={`/ressort/${entry.id}`}
                                  className=""
                                  onClick={(e) => {
                                    internalNavigate(e, null, entry.id);
                                  }}
                                >
                                  {entry.title}
                                </Link>
                              </div>
                            )}
                            {entry.type == EventCategoryType.Detail && (
                              <div className="list-item-add">
                                <Link
                                  key={`linked-ressort-${entry.id}`}
                                  href={`/article/${entry.id}`}
                                  className=""
                                  onClick={(e) => {
                                    internalNavigate(e, entry.id, null);
                                  }}
                                >
                                  {entry.title}
                                </Link>
                              </div>
                            )}
                            {!isIncluded && !isMaxNews && (
                              <button
                                aria-label="Zu Favoriten hinzufügen"
                                className={`add-item ${
                                  isIncluded ? "included" : " "
                                }`}
                                onClick={() => {
                                  addToMyNews(entry);
                                }}
                              >
                                <Heart />
                              </button>
                            )}
                            {!isIncluded && isMaxNews && (
                              <button
                                onClick={() => {
                                  setShowError(true);
                                }}
                                className={`add-item`}
                                aria-label="Zu Favoriten hinzufügen"
                              >
                                <Heart />
                              </button>
                            )}
                            {isIncluded && (
                              <button
                                onClick={() => {
                                  removeFromMyNews(entry);
                                }}
                                className={`add-item included`}
                                aria-label="Von Favoriten entfernen"
                              >
                                <Heart />
                              </button>
                            )}
                          </div>
                        )}
                      {entry.type == EventCategoryType.Web && entry.link && (
                        <Link
                          key={`linked-webview-${entry.id}`}
                          href={entry.link}
                          target="_blank"
                          className="btn btn-primary btn-discreet"
                        >
                          {entry.title}
                        </Link>
                      )}
                    </React.Fragment>
                );
              })}
            </div>
          </div>
          {showError && (
            <div className="pt-4 text-xs">
              Es können maximal drei Favoriten ausgewählt werden. Sie können
              Ihre Favoriten über das Hauptmenü verwalten.
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default LinkedCategories;
